import React from 'react';
import { Redirect } from 'react-router-dom';

class Logout extends React.Component {
    componentDidMount(){
        localStorage.removeItem('token-pod');
        // localStorage.removeItem('userdata-pod');
        this.props.updateLogin();
    }
    render() {
        return (
            <React.Fragment>
                <Redirect to="/"/>
            </React.Fragment>
        )
    }
}
export default Logout;
